export default __webpack_public_path__ + "static/media/093-exchange-1.c8c7f012.png";